import { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { PencilIcon, PhoneIcon } from './icons'
import { InfoItem } from './settings/AccountPanel'
import { saveContactPhone } from '../services/tenant'
import { formatPhone, phoneE164, phoneProblem } from '../utils/phone'

/**
 * Ayarlar › Hesabım: iletişim telefonu. Kayıtta alınan numara; patron buradan
 * değiştiriyor. Okurken düz satır, "Değiştir"e basınca kutu.
 */
export function ContactPhoneSetting() {
  const { tenantId, contactPhone } = useAuth()
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const start = () => {
    setValue(contactPhone ? formatPhone(contactPhone) : '')
    setError(null)
    setEditing(true)
  }

  const save = async () => {
    const problem = phoneProblem(value)
    if (problem) {
      setError(problem)
      return
    }
    if (!tenantId) return
    setBusy(true)
    try {
      await saveContactPhone(tenantId, phoneE164(value))
      setEditing(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Kaydedilemedi.')
    } finally {
      setBusy(false)
    }
  }

  // Düzenlerken kutu ve düğmeler satırın içinde alt alta: yan yana dar
  // kartın dışına taşıyordu (kullanıcı, 13 Eki 2026).
  if (editing) {
    return (
      <div className="ainfo__item ainfo__item--edit">
        <span className="ainfo__icon" aria-hidden="true">
          <PhoneIcon />
        </span>
        <div className="ainfo__body">
          <label className="ainfo__label" htmlFor="contact-phone">
            İletişim telefonu
          </label>
          <input
            id="contact-phone"
            className="ainfo__input"
            type="tel"
            inputMode="tel"
            value={value}
            onChange={(e) => setValue(formatPhone(e.target.value))}
            onKeyDown={(e) => e.key === 'Enter' && void save()}
            placeholder="(5xx) xxx xx xx"
          />
          {error && <span className="ainfo__error">{error}</span>}
          <div className="ainfo__edit-buttons">
            <button type="button" className="btn btn--ghost btn--sm" disabled={busy} onClick={() => setEditing(false)}>
              Vazgeç
            </button>
            <button type="button" className="btn btn--primary btn--sm" disabled={busy} onClick={() => void save()}>
              {busy ? 'Kaydediliyor…' : 'Kaydet'}
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <InfoItem
      icon={<PhoneIcon />}
      label="İletişim telefonu"
      action={
        <button
          type="button"
          className="icon-btn"
          onClick={start}
          title="Değiştir"
          aria-label="İletişim telefonunu değiştir"
        >
          <PencilIcon />
        </button>
      }
    >
      {contactPhone ? formatPhone(contactPhone) : <span className="setting__muted">girilmemiş</span>}
    </InfoItem>
  )
}
